import { render } from "./RejectDisputeModal.vue?vue&type=template&id=3e35ce70&scoped=true"
import script from "./RejectDisputeModal.vue?vue&type=script&lang=js"
export * from "./RejectDisputeModal.vue?vue&type=script&lang=js"

import "./RejectDisputeModal.vue?vue&type=style&index=0&id=3e35ce70&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e35ce70"]])

export default __exports__